import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { useHover, useActive } from 'react-native-web-hooks';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import Icon from '../icon';
const StyledIconDiv = styled.View`
  flex-direction: ${props => props.trailing ? 'row' : 'row-reverse'};
`;
const StyledPressable = styled.Pressable`
  flex-direction: ${props => props.trailing ? 'row' : 'row-reverse'};
  justify-content: center;
`;
const Types = ['default', 'subtle'];
const Sizes = ['regular', 'small'];
const color = {
  default: {
    text: Colors.purple400,
    hoverText: Colors.purple500,
    activeText: Colors.purple600,
    icon: Colors.advanceBlue400,
    iconHover: Colors.advanceBlue500,
    iconActive: Colors.advanceBlue500
  },
  subtle: {
    text: Colors.gray400,
    hoverText: Colors.gray500,
    activeText: Colors.gray600
  },
  small: {
    icon: Colors.purple400,
    iconHover: Colors.purple500,
    iconActive: Colors.purple600
  }
};
export default function TextBtn(props) {
  const type = Types.includes(props.type) ? props.type : TextBtn.defaultProps.type;
  const size = Sizes.includes(props.size) ? props.size : TextBtn.defaultProps.size;
  const TextComponent = size === 'small' ? Text.BodyExtraSmall : Text.BodyBase;
  const style = size === 'small' || props.purpleIcon ? color.small : color[type];
  const ref = useRef();
  const isHovered = useHover(ref);
  const isActive = useActive(ref);
  const StyledIcon = props.iconFamily;
  const hoverStyle = {
    color: color[type].hoverText
  };
  const activeStyle = {
    color: color[type].activeText
  };
  return /*#__PURE__*/React.createElement(StyledPressable, {
    style: [styles.button, styles[type], isHovered && !props.disabled && hoverStyle, isActive && !props.disabled && activeStyle, props.disabled && styles.disabled, props.width && {
      width: props.width
    }],
    ref: ref,
    disabled: props.disabled,
    onPress: props.onPress,
    trailing: props.trailingIcon
  }, /*#__PURE__*/React.createElement(TextComponent, {
    weight: "medium",
    color: color[type].text,
    style: [isHovered && !props.disabled && hoverStyle, isActive && !props.disabled && activeStyle, styles[size]]
  }, props.children), props.icon !== '' && /*#__PURE__*/React.createElement(StyledIconDiv, {
    trailing: props.trailingIcon
  }, /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    width: true
  }), /*#__PURE__*/React.createElement(StyledIcon, {
    color: isActive && !props.disabled ? style.iconActive : isHovered && !props.disabled ? style.iconHover : style.icon,
    name: props.icon,
    size: size === 'small' ? 12 : 16
  })));
}
TextBtn.propTypes = {
  size: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string,
  icon: PropTypes.string,
  iconFamily: PropTypes.elementType,
  trailingIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
  children: PropTypes.string,
  purpleIcon: PropTypes.bool
};
TextBtn.defaultProps = {
  size: 'regular',
  type: 'default',
  width: 'auto',
  icon: '',
  iconFamily: Icon.MaterialIcons,
  trailingIcon: false,
  disabled: false,
  onPress: () => {},
  children: '',
  purpleIcon: false
};
const styles = {
  button: {
    alignItems: 'center'
  },
  default: {
    color: color.default.text
  },
  subtle: {
    color: color.subtle.text
  },
  disabled: {
    opacity: 0.4
  },
  regular: {
    lineHeight: 25.6
  },
  small: {
    lineHeight: 13
  }
};
//# sourceMappingURL=text.js.map